import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ViewportScroller } from "@angular/common";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BlogPost } from "src/app/models/blog-post";
import { BlogService } from "../../../services/blog.service";

@Component({
  selector: "app-blog-detail",
  templateUrl: "./blog-detail.component.html",
  styleUrls: ["./blog-detail.component.sass"],
})
export class BlogDetailComponent implements OnInit, OnDestroy {
  post: BlogPost;
  prevPostSlug: string;
  nextPostSlug: string;
  prevPostName: string;
  nextPostName: string;
  loading: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private blogService: BlogService,
    private route: ActivatedRoute,
    private viewportScroller: ViewportScroller,
  ) {}

  ngOnInit(): void {
    // Subscribe to route parameter changes
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const slug = params["slug"];
      if (slug) {
        this.viewportScroller.scrollToPosition([0, 0]); // Scroll to top
        this.loadPost(slug);
        this.prevPostSlug = null;
        this.nextPostSlug = null;
        this.prevPostName = null;
        this.nextPostName = null;
      }
    });
  }

  loadPost(slug: string): void {
    this.post = null;
    this.loading = true;
    this.blogService.getPostBySlug(slug).subscribe((response) => {
      this.post = response.data;
      this.loading = false;
      this.loadPreviousPost();
      this.loadNextPost();
      this.blogService
        .getAuthorById(response.data.author.id)
        .subscribe((authorResponse) => {
          this.post.author = authorResponse.data;
        });
    });
  }

  loadPreviousPost(): void {
    this.blogService
      .getPreviousPost(this.post.createdAt)
      .subscribe((response) => {
        this.prevPostSlug = response ? response.slug : null;
        this.prevPostName = response ? response.title : null;
      });
  }

  loadNextPost(): void {
    this.blogService.getNextPost(this.post.createdAt).subscribe((response) => {
      this.nextPostSlug = response ? response.slug : null;
      this.nextPostName = response ? response.title : null;
    });
  }

  getImageUrl(url: string): string {
    return this.blogService.getImageUrl(url);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
